export default __webpack_public_path__ + "static/2-1547f693fedc072ee06c3a0331688853.jpg";